import PageFooter from './page-footer';

export default PageFooter;
